import type { Case } from "@repo/provider-network";

type Clinician = NonNullable<Case["case_assignment"]>["clinician"];

/**
 * Renders a clinician name as "Dr. <first> <last>", drawing from whichever
 * of first_name / last_name are populated. Returns "" if the clinician is
 * missing or has no name fields set.
 */
export function formatClinicianName(clinician: Clinician | undefined): string {
  if (!clinician) return "";
  const parts = [clinician.first_name, clinician.last_name].filter(Boolean);
  return parts.length ? `Dr. ${parts.join(" ")}` : "";
}

/**
 * Renders a clinician name in short form ("Dr. <First>"), preferring the
 * first name and falling back to last name when only a surname is known
 * (e.g. Blueberry "Dr. Smith" data).
 */
export function formatClinicianShortName(
  clinician: Clinician | undefined
): string {
  if (!clinician) return "";
  const name = clinician.first_name || clinician.last_name;
  return name ? `Dr. ${name}` : "";
}
